// Define the sauna models data as a dictionary
const bundleModels = {
  "Iron Neck Strength Bundle": {
    image:
      "https://cdn.shopify.com/s/files/1/0585/1224/4854/files/iron-neck-strength-bundle-577812.webp?v=1734674050",
    imageBtnLink:
      "https://peakprimalwellness.com/products/iron-neck-strength-bundle",
    description:
      "The Strength Bundle focuses on building neck strength, posture, and mobility for athletes and fitness enthusiasts.",
    features: [
      "Iron Neck 3.0 Pro",
      "Alpha+ Harness",
      "25 lb Band",
      "35 lb Band",
      "50 lb Band",
      "Drawstring Bag",
      "3X Anchors",
      "Premium Training",
    ],
  },
  "Iron Neck Rehab Bundle": {
    image:
      "https://cdn.shopify.com/s/files/1/0585/1224/4854/files/iron-neck-rehab-bundle-102479.webp?v=1734674167",
    imageBtnLink:
      "https://peakprimalwellness.com/products/iron-neck-rehab-bundle",
    description:
      "The Rehab Bundle is tailored for recovery, mobility improvement, and pain relief.",
    features: [
      "Iron Neck 3.0 Pro",
      "5 lb Band",
      "10 lb Band",
      "25 lb Band",
      "Drawstring Bag",
      "3X Anchors",
      "Premium Training",
    ],
  },
};

// Collect all unique features from all sauna models
const allFeatures = new Set();
Object.values(bundleModels).forEach((model) => {
  model.features.forEach((feature) => allFeatures.add(feature));
});

// Function to render the sauna models table dynamically
function renderSaunaTable() {
  const container = document.getElementById("sauna-table-container");

  let tableHTML = "<table>";

  // Header Row
  tableHTML += "<tr><th>Features</th>";
  for (const modelName in bundleModels) {
    tableHTML += `<th>${modelName}</th>`;
  }
  tableHTML += "</tr>";

  // Rows for Capacity, Heaters, Weight Capacity, Interior & Exterior Dimensions, Operating Voltage, Watts, Plug Type, and Weight
  const staticRows = [
    { label: "", key: "image" },
    { label: "Description	", key: "description" },
  ];

  staticRows.forEach((row) => {
    tableHTML += `<tr><td>${row.label}</td>`;
    for (const modelData of Object.values(bundleModels)) {
      tableHTML += `<td>`;
      if (row.key === "image") {
        // If the row is for the image, render the image
        tableHTML += `<div>
            <img src="${modelData.image}" alt="${modelData.standardDryWeight}" width="100%" height="250" style="object-fit: contain;">
            <button class="bundle-comparison-cart-btn" onclick="window.open('${modelData.imageBtnLink}', '_blank');">
            Add to Cart
          </button>
          </div>`;
      } else {
        // Otherwise, render the text content
        tableHTML += `${modelData[row.key]}`;
      }
      tableHTML += `</td>`;
    }
    tableHTML += "</tr>";
  });

  // Rows for each feature
  allFeatures.forEach((feature) => {
    tableHTML += `<tr><td>${feature}</td>`;
    for (const modelName in bundleModels) {
      const hasFeature = bundleModels[modelName].features.includes(feature);
      tableHTML += `<td>${
        hasFeature ? '<span class="tick">✓</span>' : ""
      }</td>`;
    }
    tableHTML += "</tr>";
  });

  tableHTML += "</table>";
  container.innerHTML = tableHTML;
}

function renderSaunaBundles() {
  const saunaContainer = document.querySelector(
    ".bundle-comparison-mobile-flex"
  );

  // Loop through each sauna model to create HTML for each bundle
  // Loop through each sauna model to create HTML for each bundle
  for (const [modelName, modelData] of Object.entries(bundleModels)) {
    let bundleHtml = `
      <div class="bundle-comparison-mobile-dropdown-flex">
        <div class="mobile-bundle-comp-flex">
          <div class="dropdownflex">
            <div class="dropdownmovement-flex">
              <p>${modelName}</p>
              <img src="https://cdn.shopify.com/s/files/1/0585/1224/4854/files/downwardArrow.png?v=1730976256" loading="lazy" />
            </div>
          </div>
          <div class="bundle-comparison-flex">
            <div class="dropdownmovement-flex-img">
              <img src="${modelData.image}" loading="lazy" />
            </div>
            <button class="bundle-comparison-cart-btn" onclick="window.open('${modelData.imageBtnLink}', '_blank');">
              Add to Cart
            </button>
            <h6>Model</h6>
            <p>${modelName}</p>
    `;

    // Dynamically add available data from the object
    const fields = [
      { label: "Description", key: "description" },
      { label: "Standard Dimensions", key: "standardDimensions" },
      { label: "Standard Dry Weight", key: "standardDryWeight" },
      {
        label: "Standard Filled Weight (with 97 US Gallons)",
        key: "standardFilledWeight",
      },
      { label: "X-Large Dimensions", key: "xlargeDimensions" },
      { label: "X-Large Dry Weight", key: "xlargeDryWeight" },
      {
        label: "X-Large Filled Weight (with 100 US Gallons)",
        key: "xlargeFilledWeight",
      },
    ];

    fields.forEach((field) => {
      if (modelData[field.key]) {
        bundleHtml += `
          <h6>${field.label}</h6>
          <p>${modelData[field.key]}</p>
        `;
      }
    });

    // Add Features Section if it exists
    if (modelData.features && modelData.features.length > 0) {
      bundleHtml += `
        <h6>What's included</h6>
      `;
      modelData.features.forEach((feature) => {
        bundleHtml += `<p>${feature}</p>`;
      });
    }

    // Close the flex div
    bundleHtml += `
          </div>
        </div>
      </div>
    `;

    // Append the HTML to the container
    saunaContainer.innerHTML += bundleHtml;
  }
}

// Call the function to render sauna bundles on page load
document.addEventListener("DOMContentLoaded", renderSaunaTable);
document.addEventListener("DOMContentLoaded", renderSaunaBundles);

document.addEventListener("DOMContentLoaded", () => {
  // Close all .bundle-comparison-flex sections by default
  document.querySelectorAll(".bundle-comparison-flex").forEach((section) => {
    section.style.maxHeight = "0";
  });

  // Add click event listeners to all .dropdownmovement-flex elements
  document.querySelectorAll(".dropdownmovement-flex").forEach((dropdown) => {
    dropdown.addEventListener("click", function () {
      const bundleComparisonFlex = this.closest(
        ".mobile-bundle-comp-flex"
      ).querySelector(".bundle-comparison-flex");
      const isOpen = bundleComparisonFlex.style.maxHeight !== "0px";
      bundleComparisonFlex.style.maxHeight = isOpen
        ? "0"
        : `${bundleComparisonFlex.scrollHeight}px`;

      const arrowImg = this.querySelector("img"); // Assuming the img is directly within .dropdownmovement-flex
      if (arrowImg) {
        arrowImg.classList.toggle("rotate-arrow", !isOpen); // Add the class if closing, remove if opening
      }
    });
  });
});
